import React from 'react';

export const PrimaryButton = ({
  children,
  onClick,
  disabled,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="px-6 py-2 rounded-md font-16 font-medium text-white 
       hover:opacity-90 transition flex items-center gap-2"
      style={{
        background: 'linear-gradient(90deg, rgba(111,114,255,0.4) 0%, rgba(39,200,246,0.4) 100%)',
      }}
    >
      {children}
    </button>
  );
};
